import { jsx as t } from "react/jsx-runtime";
function r(e) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...e,
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M1.92684 0.666649V11.3333M9.92684 0.666649V11.3333M3.26017 0.666649H0.593506M9.92684 5.99998L1.92684 5.99998M3.26017 11.3333H0.593506M11.2602 11.3333H8.59351M11.2602 0.666649H8.59351",
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  r as default
};
